import { usePostHog } from 'posthog-js/react';
import React, { createContext, useEffect, useState } from 'react';

export const BrcContext = createContext();

function BrcContextWrapper({ children }) {
  const [show, setShow] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [detailsShow, setDetailsShow] = useState(false);
  const [exportShow, setExportShow] = useState(false);
  const [sessionUser, setSessionUser] = useState({});
  const [campaignColumns, setCampaignColumns] = useState([
    'detailedStatus',
    'name',
    'campaignDemandSource',
    'country',
    'industry',
    'startDate',
    'endDate',
    'firstImpressionDate',
    'votes',
    'views',
    'actions',
  ]);
  const [questionColumns, setQuestionColumns] = useState([
    'brandMetricType',
    'prefRateExposed',
    'prefRateControl',
    'absoluteLift',
    'relativeLift',
    'significance',
  ]);
  const postHog = usePostHog();

  useEffect(() => {
    if (!postHog?._isIdentified() && sessionUser?.sub) {
      postHog?.identify(sessionUser.sub, { email: sessionUser.email });
    }
  }, [postHog, sessionUser]);

  const toggleShow = () => {
    setShow((prevShow) => !prevShow);
  };

  const toggleDelete = () => {
    setDeleteShow((prevDeleteShow) => !prevDeleteShow);
  };

  const toggleDetails = () => {
    setDetailsShow((prevDetailsShow) => !prevDetailsShow);
  };

  const toggleExport = () => {
    setExportShow((prevExportShow) => !prevExportShow);
  };

  const toggleIsEdit = (event) => {
    setIsEdit(event);
  };

  return (
    <BrcContext.Provider
      value={{
        show,
        toggleShow,
        deleteShow,
        toggleDelete,
        isEdit,
        toggleIsEdit,
        toggleDetails,
        detailsShow,
        toggleExport,
        exportShow,
        sessionUser,
        setSessionUser,
        campaignColumns,
        setCampaignColumns,
        questionColumns,
        setQuestionColumns,
      }}
    >
      {children}
    </BrcContext.Provider>
  );
}

export default BrcContextWrapper;
